export const actionServiceInfoTypes = {
  SET_GADGETS: 'SET_GADGETS' as const,
  SET_LOADING: 'SET_LOADING' as const,
  SET_SELECTED_GADGET: 'SET_SELECTED_GADGET' as const,
  SET_SELECTED_SERVICE_INFO: 'SET_SELECTED_SERVICE_INFO' as const,
  SET_CHOOSEN_MODAL: 'SET_CHOOSEN_MODAL' as const,
};
